import { handleOrganisationRoutes } from '@/helpers/router';
import { DEFAULT_ABILITIES } from '@/helpers/auth';
export default [
    {
        path: '/organisation/:orgUuid/vintage-products/:vintageProductUuid',
        name: 'vintage-products-show',
        component: () => import('@/views/organisation/vintage-products/Show.vue'),
        meta: {
            resource: DEFAULT_ABILITIES.USER_LOGGED_IN.subject,
            action: DEFAULT_ABILITIES.USER_LOGGED_IN.action,
            pageTitle: 'pageTitles.vintageProducts.show',
            breadcrumb: [
                {
                    text: 'breadcrumbs.vintageProducts.show.vintageProducts',
                },
                {
                    text: 'breadcrumbs.vintageProducts.show.details',
                    active: true,
                },
            ],
        },
        beforeEnter: (to, from, next) => {
            handleOrganisationRoutes(to);
            next();
        },
    },
];
